import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import { DivIcon } from 'leaflet';
import { renderToStaticMarkup } from 'react-dom/server';
import { Marker, Popup } from 'react-leaflet';
import MapMarkerIcon from '../MapMarkerIcon';
import { getThemeByTenantId, TENANTS } from '@topconagriculture/theme';
const MapMarker = (props) => {
    const { marker, selectedMarker, onMarkerClick } = props;
    const isActive = selectedMarker && marker.useSelectedMarkerStyle ? marker.id === selectedMarker.id : false;
    return (React.createElement(Marker, { position: marker.location, key: marker.id, onClick: (event) => onMarkerClick(event, marker), pmIgnore: true, icon: new DivIcon({
            html: renderToStaticMarkup(React.createElement(MuiThemeProvider, { theme: getThemeByTenantId(TENANTS.TOPCON).theme },
                React.createElement(MapMarkerIcon, { marker: marker, isActive: isActive }))),
            iconSize: [0, 0],
        }), onMouseOver: (e) => {
            var _a, _b;
            (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.openPopup) === null || _b === void 0 ? void 0 : _b.call(_a);
        }, onMouseOut: (e) => {
            var _a, _b;
            (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
        } }, marker.popup && (React.createElement(Popup, { closeButton: false },
        React.createElement("span", { style: { textAlign: 'start' }, dangerouslySetInnerHTML: { __html: marker.popup } })))));
};
export default MapMarker;
//# sourceMappingURL=MapMarker.js.map